/**
 *  根据多语言返回错误信息
 */
import Cookies from 'js-cookie';
import storeLocal from 'store';
import cnErrorMsg from '@/language/cnErrorMessage';
import enErrorMsg from '@/language/enErrorMessage';
import hkErrorMsg from '@/language/hkErrorMessage';

let user_language = {
  UNKNOWN: 0,         //UNKNOWN
  CN: 1,         //中文简体
  HK: 2,         //中文繁体
  EN: 3,         //英文
  JP: 4,         //日语
  KR: 5,         //韩语
};
let langErrorMsg = cnErrorMsg;
let configSetting = storeLocal.get('Pwm-configSetting');
if (configSetting) {
  switch (configSetting.displaySetting.language) {
    case user_language.CN:
      langErrorMsg = cnErrorMsg;
      break;
    case user_language.EN:
      langErrorMsg = enErrorMsg;
      break;
    case user_language.HK:
      langErrorMsg = hkErrorMsg;
      break;
  }
}
export default langErrorMsg



// WEBPACK FOOTER //
// ./src/language/getErrorMessage.js